const videoGuide = document.getElementById("how-to-use-guide");
const fullscreenButtonGuide = document.querySelector(".full-screen-guide");

fullscreenButtonGuide.addEventListener("click", function () {
  if (videoGuide.webkitSupportsFullscreen) {
    videoGuide.webkitEnterFullscreen();
    return;
  }

  videoGuide.requestFullscreen();
});

document.addEventListener("fullscreenchange", function () {
  if (document.fullscreenElement) {
    videoGuide.setAttribute("controls", true);
    return;
  }

  videoGuide.removeAttribute("controls");
});